globalThis.l = console.log;
l('========================================================================');
globalThis.HYBRILIOR_START = new Date();
l('HYBRILIOR START', HYBRILIOR_START);